import { METRICS_EVENTS } from "@cede/types";
import { useOnboarding } from "./useOnboarding";
import { useTrackEvent } from "@/hooks/data/useMetricsEvents";
import { useSocialAccounts } from "@/hooks/socials/useSocialAccounts";
import { useHubUser } from "@/hooks/user/useHubUser";
import { ONBOARDING_STEPS } from "@/store/onboardingStore";
import { isEligibleToTrade } from "@/utils/onboarding";

export const useConnectSocialStep = () => {
  const { currentStep } = useOnboarding();
  const { hubUser } = useHubUser();
  const { socialAccounts } = useSocialAccounts();

  const isStepActive = currentStep === ONBOARDING_STEPS.CONNECT_SOCIAL;

  // Check eligibility
  const userIsEligibleToTrade = isEligibleToTrade(hubUser, socialAccounts);

  // Track when user views the social account connection step during onboarding
  useTrackEvent({
    event: METRICS_EVENTS.ONBOARDING_SOCIAL_STEP_VIEWED,
    properties: () => ({
      has_social_accounts: socialAccounts.length > 0,
      social_accounts_count: socialAccounts.length,
      is_eligible_to_trade: userIsEligibleToTrade,
    }),
    enabled: isStepActive,
  });

  return {
    isEligibleToTrade: userIsEligibleToTrade,
  };
};
